import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import { SnackBarComponent } from "../components/snack-bar/snack-bar.component";
import { StorageService } from "../services/storage.service";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    public snackBar: MatSnackBar,
    public storageService: StorageService,
    private router: Router
  ) { }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {

    return next.handle(request).pipe(
      catchError((err) => {
        if (!window.navigator.onLine) {
          this.customSnackBar(
            "Network Error! Check your Internet Connection",
            "error"
          );
        } 
        if (this.router.url.includes("login")) {
          if ([401].indexOf(err.status) !== -1) {
            this.customSnackBar(
              "Permission denied by security module, Redirecting to login page",
              "error"
            );
            this.storageService.clearUserLoginData();
            this.router.navigateByUrl("/login");
          }
          else if ([403].indexOf(err.status) !== -1) {
            this.persistInvalidLoginError(err);
            this.redirectToInvalidLogin(true);
          }
          else if ([409].indexOf(err.status) !== -1) {
            this.persistInvalidLoginError(err);
            this.redirectToInvalidLogin(true);
          }
          else {
            this.persistInvalidLoginError(err);
            this.redirectToInvalidLogin();
          }
        }
        else {
          if ([403].indexOf(err.status) !== -1) { 
            this.persistInvalidLoginError(err?.error);
            this.redirectToInvalidLogin(true);
          }
          else if ([409].indexOf(err?.status) !== -1) {            
            this.showErrorMessage(err);
          }
          else {
            this.showErrorMessage(err);
          }
        }

        return throwError(() => err);
      })
    );
  }

  private showErrorMessage(error: any): void {
    if (error?.error?.message) {
      this.customSnackBar(error?.error?.message, "error");
    } else if (error?.message) {
      this.customSnackBar(error?.message, "error");
    } else {
      this.customSnackBar("error occured", "error");
    }
  }


  private persistInvalidLoginError(payload: unknown): void {
    const source = payload && typeof payload === "object"
      ? payload as { code?: number; data?: string; message?: string }
      : {};
    const errorMessage = source.data || source.message || "error_page_message_for_user";
    const errorCode = typeof source.code === "number" ? source.code : 400;
    sessionStorage.setItem("error-message", JSON.stringify({ code: errorCode, message: errorMessage }));
  }

  private redirectToInvalidLogin(withDelay = false): void {
    if (withDelay) {
      setTimeout(() => {
        this.router.navigate(["/login/invalid-login"]);
      }, 1000);
      return;
    }

    this.router.navigate(["/login/invalid-login"]);
  }

  customSnackBar(message: string, type: string): void {
    this.snackBar.openFromComponent(SnackBarComponent, {
      data: {
        message,
        type,
      },
      duration: 3000,
    });
  }
}
